<template>
  <div class="zeus-content" :data-exp="epxParam" :style="getPageStyles()" :class="{ mask }">
    <template v-if="defaultShowPage">
      <page
        v-for="page in pageData"
        :key="page.id"
        :data="page"
        :mask="mask"
        :site-data="siteData"
      />
    </template>
  </div>
</template>

<script>
  import Page from './page'

  export default {
      'props': {
          'siteData': {
              'type': Object,
              'default': () => ({})
          },
          'mask': Boolean
      },
      'computed': {
          epxParam() {
              return `code=${this.$root.productName}_entry`
          },
          pageData() {
              // return this.siteData.pageData
              return [
                  ...(this.siteData.pageData || []),
                  ...(this.siteData.fixedData || [])
              ]
          },
          defaultShowPage() {
            const dp = {}
            const data = [...this.siteData.fixedData, ...this.siteData.pageData]
            for (let i = 0; i < data.length; i++) {
                const item = data[i]
                const pr = item?.options?.basic?.pageRouter || 'default'
                dp[pr] = dp[pr] || []
                dp[pr].push(item.id)
            }
            this.$root.pageRouter = { ...dp }

            if (!this.$root.pageRouter[this.$root.currentRouter]) {
              this.$root.currentRouter = 'default'
            }

            return true
          }
      },
      'methods': {
          getPageStyles() {
              return { 'minHeight': window.$isEditing ? '0' : '100vh' }
          }
      },
      'components': { Page }
  }
</script>

